import React, { useRef, useState } from 'react'
import { ACCEPTED_FORMATS, ACCEPTED_MIME_TYPES, DROP_ZONE_TEXT } from './constants'
import { getDropZoneStyle, dropZoneStyles } from './styles'

interface Props {
  onFilesSelected: (files: File[]) => void
}

const DropZone: React.FC<Props> = ({ onFilesSelected }) => {
  const [isDragging, setIsDragging] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  const handleFiles = (files: FileList | null) => {
    if (!files) return
    const valid = Array.from(files).filter((f) =>
      ACCEPTED_MIME_TYPES.includes(f.type)
    )
    if (valid.length > 0) onFilesSelected(valid)
  }

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault()
    setIsDragging(true)
  }

  const handleDragLeave = () => setIsDragging(false)

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault()
    setIsDragging(false)
    handleFiles(e.dataTransfer.files)
  }

  const handleClick = () => inputRef.current?.click()

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleFiles(e.target.files)
  }

  return (
    <div
      style={getDropZoneStyle(isDragging)}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
    >
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPTED_FORMATS}
        multiple
        onChange={handleChange}
        style={{ display: 'none' }}
      />
      <div style={dropZoneStyles.icon}>📄</div>
      <div style={dropZoneStyles.title}>{DROP_ZONE_TEXT.title}</div>
      <div style={dropZoneStyles.subtitle}>{DROP_ZONE_TEXT.subtitle}</div>
      <div style={dropZoneStyles.formats}>{DROP_ZONE_TEXT.formats}</div>
    </div>
  )
}

export default DropZone
